import { render, staticRenderFns } from "./ArticleAddPage.vue?vue&type=template&id=a40e0726&scoped=true&"
import script from "./ArticleAddPage.vue?vue&type=script&lang=js&"
export * from "./ArticleAddPage.vue?vue&type=script&lang=js&"
import style0 from "./ArticleAddPage.vue?vue&type=style&index=0&id=a40e0726&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a40e0726",
  null
  
)

export default component.exports